import { render, staticRenderFns } from "./companyMarketingInfo.vue?vue&type=template&id=59d8593b&scoped=true"
import script from "./companyMarketingInfo.vue?vue&type=script&lang=js"
export * from "./companyMarketingInfo.vue?vue&type=script&lang=js"
import style0 from "./companyMarketingInfo.vue?vue&type=style&index=0&id=59d8593b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59d8593b",
  null
  
)

export default component.exports